import React, { Component } from 'react';
import { getBilldetail, } from "./services";
import {
    Toast,

} from 'antd-mobile';

import './index.scss';
import wx from 'weixin-js-sdk';
import { GetRequest } from "../../utils/util";
var browser = {
    versions: function () {
        var u = navigator.userAgent;
        return {
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
            wx: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
            ali: u.indexOf('AlipayClient') > -1
        };
    }(),
}
class Billdetail extends Component {
    ref = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            billdetail: {},
            showModal: false,
            btnContent: '--',
            tipContent: '确定',
            pay: false,
            tip: false,
            showModalErr: false,
            errtipContent: "您还未授权，请先去钱包页面授权后，再重新请求代扣",
            sTitle: '',
            isGzh: false
        }
    }
    initData() {
        // this.getBilldetailFn()
        // return;
        var ua = navigator.userAgent.toLowerCase();

        if (browser.versions.ios) {
            console.log(GetRequest().data);
            let data = JSON.parse(GetRequest().data);
            window.localStorage.setItem('token', data.token);
            this.setState({
                projectId: data.projectId,
                accountId: data.accountId,
                orderId: data.orderId,
                token: data.token,
                telephone: data.telephone,
                consumeDate: data.consumeDate,
                orderNo: data.orderNo,
                menuQryFlag: data.menuQryFlag,
                roomId: data.roomId,
                operatorId: data.operatorId
            }, () => {
                const { accountId, projectId, orderId, token, telephone, orderNo, menuQryFlag, roomId, operatorId } = this.state;
                this.getBilldetailFn(accountId, projectId, orderId, token, telephone, orderNo, menuQryFlag, roomId, operatorId);
            })
            return;
        }
    }
    // http://localhost:3000/billDetail?data={%22accountId%22:%223022%22,%20%22projectId%22:%22464%22,%20%22orderId%22:%221050710971976397318%22,%20%22token%22:13266759226,219555%22,%20%22telephone%22:%2214640000028%22,%22orderNo%22:%2213202401311031273685%22,%22menuQryFlag%22:%22menuQryFlag%22,%22roomId%22:%22%22}
    componentDidMount() {
        document.title = '账单详情';
        window.getParams = this.getParams;
        this.initData()
        // 安卓 webview 底部固定“操作订单”按钮避让：运行时强制设置滚动容器与底部预留，
        // 绕开 CSS 继承异常/缓存旧样式导致 padding 失效的问题
        this.fixBottomSpace();
        window.addEventListener('resize', this.fixBottomSpace);
    }
    fixBottomSpace = () => {
        const container = document.querySelector('.billdetail_container');
        if (!container) return;
        // 强制容器高度等于可视高度，保证内部可滚动（绕开 height:inherit 在部分安卓内核异常）
        container.style.height = window.innerHeight + 'px';
        container.style.overflowY = 'auto';
        container.style.boxSizing = 'border-box';
        // 分层设置底部预留：先设普通值，再尝试叠加安全区；
        // 老内核不支持 env() 时会忽略第二条赋值，保留 180px 兜底
        container.style.paddingBottom = '180px';
        container.style.paddingBottom = 'calc(180px + env(safe-area-inset-bottom))';
    };
    componentWillUnmount() {
        window.removeEventListener('resize', this.fixBottomSpace);
    }
    getParams = (accountId, projectId, orderId, token, telephone, orderNo, menuQryFlag, roomId, operatorId) => {
        window.localStorage.setItem('token', token);
        this.setState({
            projectId, accountId, orderId, token, telephone,
            orderNo, menuQryFlag, roomId, operatorId
        }, () => {
            this.getBilldetailFn(accountId, projectId, orderId, token, telephone, orderNo, menuQryFlag, roomId, operatorId);
        })
    }
    getBilldetailFn = (accountId, projectId, orderId, token, telephone, orderNo, menuQryFlag, roomId, operatorId) => {
        let params = {
            orderNo,
            // menuQryFlag,
            // roomId,
            // accountId,
            token: token,
            // telephone,
            projectId,
            orderId,
            operatorId,
        }
        if (accountId) {
            params.accountId = accountId
        }
        if (telephone) {
            params.telephone = telephone
        }
        if (roomId) {
            params.roomId = roomId
        }
        if (menuQryFlag) {
            params.menuQryFlag = menuQryFlag
        }
        
        console.log(params,'params');
        
        getBilldetail(params).then((res) => {
            if (res.errorCode == 0) {
                let num = (res.data.consumeDate).replace(/[^0-9]/ig, "");
                res.data.orderNumber = num;

                this.setState({
                    billdetail: res.data
                });

            } else {
                Toast.show(res.errorMessage)
            }
        })
    }
    showTip = () => {
        this.setState({
            pay: false,
            tip: true,
            tipContent: "由于现场网络信号不稳或和设备蓝牙连接断开，导致该笔消费数据未结算。您可以尝试通过手机蓝牙再次连接该设备（<span style='color:#FC5A5A'>不需要点击使用</span>）进行自动结算，或者等待设备在线(连接)后自动结算"
            , btnContent: "我知道了"
        }, () => {
            this.setState({ showModal: true })
        })
    }

    renderModal = () => {
        const { showModal, btnContent, tipContent, tip } = this.state;
        return (
            <>
                {/* 底部透明灰色层  */}
                <div className={showModal ? "mask display2" : "mask"}></div>
                {/* <!-- 提示层 --> */}
                <div className={showModal ? "board display" : "board"}>
                    <div className="titile"><span>提示</span></div>
                    <div className='content mg30' style={{ border: 0 }}>
                        <div className="text-box">
                            <span dangerouslySetInnerHTML={{ __html: tipContent }} className={tip ? "t_value_center left" : "t_value_center"}></span>
                        </div>
                    </div>
                    <div className="modal-btn-box">
                        <span className="towBtn bgb" onClick={() => this.submit()}>{btnContent}</span>
                    </div>
                </div>
            </>
        )
    }
    renderModalErr = () => {
        const { showModalErr, errtipContent, sTitle } = this.state;
        return (
            <>
                {/* 底部透明灰色层  */}
                <div className={showModalErr ? "mask display2" : "mask"}></div>
                {/* <!-- 提示层 --> */}
                <div className={showModalErr ? "board display" : "board"}>
                    <div className="titile"><span>{sTitle || '提示'}</span></div>
                    <div className='content mg30' style={{ border: 0 }}>
                        <div className="text-box">
                            <div dangerouslySetInnerHTML={{ __html: errtipContent }} className={sTitle ? "t_value_center left" : "t_value_center"}></div>
                        </div>
                    </div>
                    <div className="modal-btn-box">
                        <span className="towBtn bgb" onClick={() => this.clickHandler()}>我知道了</span>
                    </div>
                </div>
            </>
        )
    }
    clickHandler = () => {
        this.setState({ showModal: false, showModalErr: false })
    }
    submit = () => {

        const { tip } = this.state
        if (tip) {
            this.setState({ showModal: false })
        }
    }

    render() {
        const { billdetail, isGzh } = this.state;
        const {washerRunStatusList, telephone, useType, tradeSettlement, upStatusId, deviceDescription, consumeMoney, consumeSceneType, consumeDate, uploadDate,
            waterUsageShow, waterTemperatureShow, modeInfo, thirdTradeMoney, tradeNo, settlementTime, deductType, monthConsumeMoney, walletConsumeMoney,
            preDeductMoney, consumeMoneyGiven, consumeMoneyReal, consumeSceneTypeDisplay, waterUsageShowSwitch, waterTemperatureShowSwitch, orderNumber, orderOfflineTag,
            reduceMoney, reduceRemark, originalConsumeMoney, comboType, compensateStatus, channelType, repeatDownRateStatus, compensateMoney, bigTypeId, rightLiquidInfo, leftLiquidInfo
        } = billdetail;
        return (

            <div className='billdetail_container'>
                {this.renderModal()}
                {this.renderModalErr()}
                <div className='billdetail_top'>
                    <div className='status' style={{ color: tradeSettlement == 0 && upStatusId == 1 ? '#FC5A5A' : '#5ABDFC' }}>
                        {tradeSettlement == 0 && <span>未支付</span>}
                        {tradeSettlement == 1 && <span>已支付</span>},
                        {upStatusId == 0 && <span>未完成</span>}
                        {upStatusId == 1 && <span>已完成</span>}
                        {upStatusId == 100 && <span>已关闭</span>}
                        <span style={{ visibility: upStatusId == 0 ? 'visible' : 'hidden' }} className='doubt' onClick={this.showTip}>使用完还是未完成？</span>

                    </div>
                    <div className='address'><span>{deviceDescription}</span></div>
                    <div className='address'>
                        {channelType ? <span className='bgbd'>{channelType}路</span> : ''}
                        {repeatDownRateStatus == 1 ? <span className='bgbd'>已重新启动</span> : ''}
                    </div>
                    {tradeSettlement == 0 && upStatusId == 0 && useType == 0 ? '' : <div className='amount'>{consumeMoney}
                        <span className='unit'>元</span>
                    </div>}
                </div>
                <div className='billdetail_bottom'>
                    <div className='item'>
                        <div className='title'>订单金额：</div>
                        <div className='contents'><span>{originalConsumeMoney}元</span></div>
                    </div>
                    {comboType != 0 && <div className='item' >
                        <div className='title'>优惠金额：</div>
                        <div className='contents'>
                            <span>{reduceMoney}元</span><span>({reduceRemark})</span>
                        </div>
                    </div>}
                    <div className='item'>
                        <div className='title'>支付金额：</div>
                        <div className='contents a-flex'>
                            {tradeSettlement == 0 && upStatusId == 0 && useType == 0 ? '' : <span className='amount'>{consumeMoney}元 </span>}
                            {compensateStatus == 1 ? <span className='compensateStatus'>已补款{compensateMoney}元 </span> : ''}
                        </div>
                    </div>
                    <div className='border'></div>
                    <div className='item'>
                        <div className='title'>订单号：</div>
                        <div className='contents'><span>{orderNumber}</span></div>
                        {orderOfflineTag == 1 ? <div className='offline'>延时结算订单</div> : null}
                    </div>
                    <div className='item'>
                        <div className='title'>用户手机号：</div>
                        <div className='contents'><span>{telephone}</span></div>
                    </div>
                    <div className='item'>
                        <div className='title'>消费类型：</div>
                        <div className='contents'>{consumeSceneTypeDisplay}
                        </div>
                    </div>
                    <div className='item'>
                        <div className='title'>使用时间：</div>
                        <div className='contents'><span>{consumeDate}</span></div>
                    </div>
                    {useType == 1 || bigTypeId == 18 ? '' : <div className='item'>
                        <div className='title'>完成时间：</div>
                        <div className='contents'><span>{uploadDate}</span></div>
                    </div>}
                    <div className='item' style={{ display: useType == 1 ? 'flex' : 'none' }}>
                        <div className='title'>模式：</div>
                        {bigTypeId == 16 ? <div className='contents'>
                            {leftLiquidInfo ? <div>{leftLiquidInfo}</div> : ''}
                            {rightLiquidInfo ? <div>{rightLiquidInfo}</div> : ''}

                        </div> : <div className='contents'>
                            <span>{modeInfo}</span>
                        </div>}
                    </div>
                    {tradeSettlement == 0 && upStatusId == 0 ? '' : useType == 0 ? bigTypeId == 18 ? '' : <div className='item' style={{ display: 'flex' }}>
                        <div className='title'>用水详情：</div>
                        <div className='contents'>
                            <span style={{ marginRight: '0.24rem' }}>用水量:{waterUsageShow > 0 ? waterUsageShow + "L" : "--"}</span>
                            <span>用水水温:{waterTemperatureShow > 0 ? waterTemperatureShow + "°C" : '--'}</span>
                        </div>
                    </div> : ""}
                    {preDeductMoney == 0 || bigTypeId == 18 ? '' : useType == 0 ? <div className='item'>
                        <div className='title'>钱包预扣费：</div>
                        <div className='contents'><span>{preDeductMoney}元{upStatusId == 0 ? '（未结算）' : '（已结算）'}</span></div>
                    </div> : ''}
                    {deductType == 10 ? ''
                        : walletConsumeMoney != 0 ? <div className='item'>
                            <div className='title'>钱包支付：</div>
                            <div className='contents'>
                                <span>{walletConsumeMoney}元</span>
                                （<span>{`现金余额支付:${consumeMoneyReal}元`}</span>
                                <span>{`，赠送余额支付:${consumeMoneyGiven}元`}</span>）
                            </div>
                        </div> : ''}
                    {walletConsumeMoney == 0 && tradeSettlement == 0 && deductType == 6 ? <div className='item'>
                        <div className='title'>钱包支付：</div>
                        <div className='contents'>
                            <span>{thirdTradeMoney}元（未支付）</span>
                        </div>
                    </div> : ''}
                    {tradeSettlement == 0 && upStatusId == 0 ? '' : deductType == 3 || deductType == 5 || deductType == 7 ? <><div className='item'>
                        {deductType == 3 ? <div className='title'>支付宝代扣：</div> : ''}
                        {deductType == 5 ? <div className='title'>微信代扣：</div> : ''}
                        {deductType == 7 ? <div className='title'>一卡通代扣：</div> : ''}
                        <div className='contents'><span>{thirdTradeMoney}元{tradeSettlement == 0 ? '（未支付）' : '（已支付）'}</span></div>
                    </div>
                        {tradeSettlement == 1 && tradeNo ? <div className='item'>
                            <div className='title'>代扣支付单号：</div>
                            <div className='contents'><span>{tradeNo}</span></div>
                        </div> : ''}
                        {tradeSettlement == 1 && settlementTime ? <div className='item'>
                            <div className='title'>代扣支付时间：</div>
                            <div className='contents'><span>{settlementTime}</span></div>
                        </div> : ''}
                    </> : ''}
                </div>
                {bigTypeId == 6?<div className='recordBox'>
                    <div class="containers">
                        <h5>设备运行记录</h5>
                        {washerRunStatusList&&washerRunStatusList.length>0?<ul class="timeline" >
                            {
                                washerRunStatusList.map((v,k)=>{
                                    return(
                                        <li>
                                        <div class="timeline-item">
                                            <div class="dot"></div>
                                            <div class="contents">
                                                <span class="date">{v.uploadTime}</span>
                                                <span class="status">{v.workStateDisplay}</span>
                                            </div>
                                        </div>
                                    </li>
                                    )
                                })
                            }
                        </ul>:<div className='nonetip'>暂无设备运行记录上报</div>}
                    </div>
                </div>:""}
            </div>
        )
    }
}
export default Billdetail;

